var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLoadingIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37988 1.08984C7.25815 1.08984 5.22344 1.9333 3.72314 3.43359C2.22285 4.93388 1.37988 6.96811 1.37988 9.08984C1.37988 11.2116 2.22285 13.2468 3.72314 14.7471C5.22344 16.2474 7.25815 17.0898 9.37988 17.0898C11.5016 17.0898 13.5363 16.2474 15.0366 14.7471C16.5369 13.2468 17.3799 11.2116 17.3799 9.08984",
    stroke: "white",
    strokeWidth: 1.1339,
    strokeMiterlimit: 22.9256
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLoadingIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/LoadingIcon.c356d17c.svg";
export { ForwardRef as ReactComponent };